export function ImgThink({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 508 508"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path d="M409.8,220.9C403.3,149.6,341.4,79.2,254,79.2c-86.4,0-156.6,70.3-156.6,156.6c0,61.7,36.8,118,92.6,143v16h-0.2
            c-7.8,0-14.1,6.3-14.1,14.1S182,423,189.8,423h0.2v16.5h-0.2c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h4.8
            C204,491.3,227,508,253.9,508s49.9-16.7,59.3-40.3h4.9c7.8,0,14.1-6.3,14.1-14.1c0-7.8-6.3-14.1-14.1-14.1h-0.3V423h0.3
            c7.8,0,14.1-6.3,14.1-14.1c0-7.8-6.3-14.1-14.1-14.1h-0.3v-16C378.6,351.6,416.1,288.1,409.8,220.9z M298.8,356.1
            c-5.5,2.1-9.2,7.3-9.2,13.2V444c0,19.7-16,35.7-35.7,35.7c-19.7,0-35.7-16-35.7-35.7v-74.7c0-5.9-3.7-11.2-9.2-13.2
            c-49.9-18.6-83.5-67-83.5-120.3c0-70.8,57.6-128.4,128.4-128.4c68.3,0,122.4,57.7,127.8,116.1
            C387.2,281.4,353.1,335.9,298.8,356.1z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M325.3,184.1c-5.5-5.6-14.4-5.6-19.9-0.1l-73.8,73.8l-29-29c-5.5-5.5-14.4-5.5-20,0c-5.5,5.5-5.5,14.4,0,20l39,39
            c2.8,2.8,6.4,4.1,10,4.1c3.6,0,7.2-1.4,10-4.1l83.7-83.7C330.8,198.6,330.8,189.7,325.3,184.1z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M61.3,221.7h-29c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h29c7.8,0,14.1-6.3,14.1-14.1S69.1,221.7,61.3,221.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M475.7,221.7h-29c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1h29c7.8,0,14.1-6.3,14.1-14.1
            C489.8,228,483.5,221.7,475.7,221.7z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M254,0c-7.8,0-14.1,6.3-14.1,14.1v29c0,7.8,6.3,14.1,14.1,14.1s14.1-6.3,14.1-14.1v-29C268.1,6.3,261.8,0,254,0z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M127.7,89.5L107.2,69c-5.5-5.5-14.4-5.5-20,0c-5.5,5.5-5.5,14.4,0,20l20.5,20.5c5.6,5.5,14.5,5.5,20,0
            S133.2,95.1,127.7,89.5z"/>
        </g>
      </g>
      <g>
        <g>
          <path d="M420.7,69c-5.5-5.4-14.4-5.4-19.9,0.1l-20.5,20.5c-5.5,5.5-5.5,14.4,0,20c5.5,5.5,14.4,5.5,20,0L420.7,89
            C426.2,83.5,426.2,74.6,420.7,69z"/>
        </g>
      </g>
    </svg>
  );
}